<div class="modal-header">
  <h5 class="modal-title">{{title | translate}}</h5>
</div>
<div class="modal-body">
  <span class="info-body"> {{description | translate}} </span>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary pull-right buttons"
    (click)="onConfirm()">{{'operations.' + (accept || 'operations.confirm') | translate }}</button>
  <button type="button" class="btn btn-outline-black pull-right buttons"
    (click)="onDecline()">{{'operations.' + (reject || 'operations.close') | translate }}</button>
</div>